import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const YM_ID = 82976902;

// Счётчик инициализирован с defer: true (index.html), поэтому просмотры
// отправляем сами — на первый рендер и на каждую смену маршрута.
function MetrikaTracker() {
  const { pathname, search } = useLocation();
  const referer = useRef(document.referrer);

  useEffect(() => {
    if (!window.ym) return; // локальная разработка — счётчик не подключён

    const url = window.location.href;
    window.ym(YM_ID, "hit", url, { referer: referer.current });
    referer.current = url;
  }, [pathname, search]);

  return null;
}

export default MetrikaTracker;
